import MutateEventType from "./MutateEventType";

export default MutateEventType